<template>
    <div class="page-corso-detail">
      <corso-detail />
    </div>
  </template>
  
  <script>
  import CorsoDetail from '@/components/details/CorsoDetail.vue'
  
  export default {
    name: 'ViewCorsoDetail',
    components: {
      CorsoDetail,
    },
  
    data() {
      return {
        pageName: 'CorsoDetail',
      }
    },
  
    created(){
  
    },
  
    mounted(){
      this.$eventBus.emit('page-change', {
        target: this,
        currentRoute: this.$router.currentRoute.value
      })
    },
    
  }
  </script>